import React from 'react';
import PropTypes from 'prop-types';
import {Slot} from '../Slots';
import {
  RotorFrontIcon,
  SolutionFrontIcon,
  RotorSolutionFrontIcon,
} from '../../../Icons';

const IMAGE = {
  rotor: RotorFrontIcon,
  solution: SolutionFrontIcon,
  rotorSolution: RotorSolutionFrontIcon,
};

const INSERT_ITEM_ID = 'INSERT_ITEM_ID';

/**
 * MicroConrols:
 *  - The layer over the Microcentrifuge image
 *    Used to  handle click event on centrifuge lid and controls panel area
 */
export function MicroControls(props) {
  let lidBlockPosition = {height: '100px', top: '94px'};

  if (props.isOpen) {
    lidBlockPosition = {
      height: '100px',
      top: '20px',
    };
  }

  const onClick = (callback) => (event) => {
    event.stopPropagation();
    callback();
  };

  const onDragOver = (event) => event.preventDefault();

  const onDrop = (event) => {
    const insertItemId = parseInt(event.dataTransfer.getData(INSERT_ITEM_ID));
    props.onInsertItem({
      itemId: insertItemId,
    });
  };

  const renderSlot = (slot) => (
    <Slot
      key={slot.id}
      id={slot.id}
      rotor={slot.rotor}
      image={IMAGE}
      tubeType={slot.tubeType}
      solution={slot.solution}
      contentDraggable={false}
      className={`microcentrifuge_mouth_slots_${slot.id}`}
    />
  );

  const renderDropZone = () => {
    return (
      props.isOpen && (
        <div
          className='microcentrifuge_mouth'
          onDragOver={onDragOver}
          onDrop={onDrop}
          onClick={onClick(props.openBalanceTubeModal)}>
          <div className='microcentrifuge_mouth_slots'>
            {props.slots.map(renderSlot)}
          </div>
        </div>
      )
    );
  };

  return (
    <>
      <div
        className='microcentrifuge_lidblock'
        onClick={onClick(props.toggleLid)}
        style={lidBlockPosition}
      />
      {renderDropZone()}
      <div
        className='microcentrifuge_controlsblock'
        onClick={onClick(props.openControls)}
      />
    </>
  );
}

MicroControls.propTypes = {
  /**
   * Boolean to set if lid is open/closed
   */
  isOpen: PropTypes.bool,
  /**
   * Function to invoke to open/close lid
   */
  toggleLid: PropTypes.func,
  /**
   * Function to invoke to open digital controls panel
   */
  openControls: PropTypes.func,
  /**
   * Function to invoke when an item is dropped into the centrifuge
   */
  onInsertItem: PropTypes.func,
  /**
   * Function to invoke open the balancing modal window
   */
  openBalanceTubeModal: PropTypes.func,
  /**
   * List of tubes visible in Front-View of Apparatus
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Type of Tube placed in slot
       */
      tubeType: PropTypes.string,
      /**
       * boolean to specify if solution placed
       */
      solution: PropTypes.bool,
      /**
       * Boolean to specify if rotor placed
       */
      rotor: PropTypes.bool,
    })
  ),
};

MicroControls.defaultProps = {};
